export const ImageSrc = {
    beacon: require('assets/images/beacon_icon_2.png'),
    beaconFullSize: require('assets/images/BeaconVector.png'),
    loginBackground: require('assets/images/transpBg.png'),
    suniLogo: require('assets/images/logo.svg'),
}